"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var url_types_1 = require("@wix/wix-vod-constants/dist/common/url-types");
var internal_error_1 = require("@wix/wix-vod-api-site-based/dist/src/utils/internal-error");
var to_error_1 = require("../../parsers/to-error");
var get_thumbnail_1 = tslib_1.__importDefault(require("./parsers/get-thumbnail"));
var channel_1 = require("./parsers/channel");
var youtube_1 = require("./youtube");
var getChannelsByIds = function (ids) {
    return youtube_1.service
        .getChannelsByIds(ids)
        .then(function (response) {
        return _.map(response.data.items, function (channel) {
            return channel_1.parseYoutubeChannel(url_types_1.URL_TYPES.CHANNEL, channel);
        });
    })
        .then(function (channels) { return setMissingCovers(channels); })
        .then(function (channels) {
        var realIds = _.map(channels, 'externalId');
        return tslib_1.__spreadArrays(channels, extendWithRemovedItems(ids, realIds, url_types_1.URL_TYPES.CHANNEL));
    })
        .then(function (channels) { return ({ data: channels }); })
        .catch(to_error_1.toError);
};
exports.getChannelsByIds = getChannelsByIds;
var getChannelsByUserName = function (userName) {
    return youtube_1.service
        .getChannelsByUsername(userName)
        .then(function (response) {
        return _.map(response.data.items, function (channel) {
            return channel_1.parseYoutubeChannel(url_types_1.URL_TYPES.CHANNEL, channel);
        });
    })
        .then(function (channels) { return setMissingCovers(channels); })
        .then(function (channels) { return ({ data: channels }); })
        .catch(to_error_1.toError);
};
var getPlaylistsByIds = function (ids) {
    return youtube_1.service
        .getPlayListsByIds(ids)
        .then(function (response) {
        return _.map(response.data.items, function (channel) {
            return channel_1.parseYoutubeChannel(url_types_1.URL_TYPES.PLAYLIST, channel);
        });
    })
        .then(function (playlists) {
        var realIds = _.map(playlists, 'externalId');
        return tslib_1.__spreadArrays(playlists, extendWithRemovedItems(ids, realIds, url_types_1.URL_TYPES.PLAYLIST));
    })
        .then(function (playlists) { return ({ data: playlists }); })
        .catch(to_error_1.toError);
};
var extendWithRemovedItems = function (originalIds, realIds, urlType) {
    var removedIds = _.difference(originalIds, realIds);
    return _.map(removedIds, function (id) {
        return channel_1.parseYoutubeChannel(urlType, {
            id: id,
            isExternalRemoved: true,
        });
    });
};
var getChannelsByUrl = function (url) {
    var type;
    var id;
    try {
        var result = youtube_1.service.parseChannelUrl(url);
        type = result.type;
        id = result.id;
    }
    catch (e) {
        return Promise.reject(new internal_error_1.InternalError(0, 'wpm_error.malformed_external_link'));
    }
    switch (type) {
        case url_types_1.URL_TYPES.PLAYLIST:
            return getPlaylistsByIds([id]);
        case url_types_1.URL_TYPES.USER_NAME:
            return getChannelsByUserName(id);
        default:
            return getChannelsByIds([id]);
    }
};
exports.getChannelsByUrl = getChannelsByUrl;
// 1. get all youtube channels without cover
// 2. fetch covers for from related playlists
// 3. extend with covers
// TODO: filter youtube channels only before applying this
var setMissingCovers = function (channels) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var channelsWithoutCovers, playListIds, videoCovers;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                channelsWithoutCovers = findChannelsWithMissingCover(channels);
                if (_.isEmpty(channelsWithoutCovers)) {
                    return [2 /*return*/, channels];
                }
                playListIds = _.map(channelsWithoutCovers, 'uploadsPlaylistId');
                return [4 /*yield*/, getFallbackCovers(playListIds)];
            case 1:
                videoCovers = _a.sent();
                _.forEach(channelsWithoutCovers, function (channel, index) {
                    channel.coverUrl = videoCovers[index] || null;
                });
                return [2 /*return*/, channels];
        }
    });
}); };
// eslint-disable-next-line
var findChannelsWithMissingCover = function (channels) {
    return _.reject(channels, 'coverUrl');
};
var getCoverFromPlaylistItem = function (id) {
    return youtube_1.service
        .getPlaylistItems({
        urlType: url_types_1.URL_TYPES.PLAYLIST,
        externalId: id,
        itemsCount: 1,
    })
        .then(function (response) { return response.data.items[0]; })
        .then(function (item) { return (item ? get_thumbnail_1.default(item.snippet.thumbnails) : null); });
};
var getFallbackCovers = function (playlistIds) {
    var requests = _.map(playlistIds, function (id) {
        return getCoverFromPlaylistItem(id).catch(function () { return null; });
    });
    return Promise.all(requests);
};
//# sourceMappingURL=channels.js.map